module.exports = __webpack_public_path__ + "img/img_honor2_us@3x.5ea6e362.png";